/**
 * @generated SignedSource<<a61351527bee47ec61c9e1fb309125f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastScreenAdminEditNameMutation$variables = {
  name: string;
  screenId: string;
};
export type StorecastScreenAdminEditNameMutation$data = {
  readonly storecast: {
    readonly setScreenName: {
      readonly id: string;
      readonly name: string;
    };
  };
};
export type StorecastScreenAdminEditNameMutation = {
  response: StorecastScreenAdminEditNameMutation$data;
  variables: StorecastScreenAdminEditNameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "setScreenName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminEditNameMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastScreenAdminEditNameMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "cc605a23685f5e4816e55a45f2f496e8",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminEditNameMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminEditNameMutation(\n  $screenId: ID!\n  $name: String!\n) {\n  storecast {\n    setScreenName(screenId: $screenId, name: $name) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0318a7840c2d7677e41b3e8f647b8972";

export default node;
